import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SharedService } from "./shared.service";
import { FormService } from "./form.service";
import { ProposalService } from "./proposal.service";
import { HttpClient } from "@angular/common/http";
import { catchError, first, map, of } from "rxjs";

@Injectable({
    providedIn: 'root'
  })
  export class LoadedFromCPService {
  
    constructor(
    private http: HttpClient,
    private sharedService: SharedService,
    private formService: FormService)
    {}


    public _isCustomerPortal: boolean = false;

    get isCustomerPortal(): boolean {
      return this._isCustomerPortal;
    }

    public _userInfo;

    get userInfo() {
      return this._userInfo;
    }


    getUserInfo(userInfo){
      this.http.get('/api/v1/cp-user-info?encryptedPackage='+userInfo).subscribe(
        res => {
          this._userInfo = res
        }
      )

    }

    loadDataForDetail2(){
    let paretnForm = this.formService.currentForm;
      paretnForm.controls['firstFirstName'].setValue(this.userInfo?.firstName);
      paretnForm.controls['firstFirstName'].disable();
      paretnForm.controls['firstCountryCode'].setValue(this.userInfo?.mobilePrefix);
      paretnForm.controls['firstPhoneNumber'].setValue(this.userInfo?.mobileNumber);
    }

    loadDataOwnerFromCP(){
        let parentForm = this.formService.currentForm;
        parentForm.controls.ownerData.controls.middleName.setValue(this.userInfo.middleName);
        parentForm.controls.ownerData.controls.lastName.setValue(this.userInfo.lastName);
        parentForm.controls.ownerData.controls.egn.setValue(this.userInfo.egn);

        parentForm.controls.ownerData.controls.egn.disable();
        parentForm.controls.ownerData.controls.lastName.disable();
        parentForm.controls.ownerData.controls.middleName.disable();
        parentForm.controls.ownerData.controls.firstName.disable();

        if(!parentForm.controls.ownerData.controls.email.value){
            parentForm.controls.ownerData.controls.email.setValue(this.userInfo.email);
        }

        if(parentForm.controls.isPropertyAddressSameAsCorrespondence.value == "N"){
            if(!parentForm.controls.ownerData.controls.address.value){
                parentForm.controls.ownerData.controls.address.setValue(this.userInfo.address);
            }
        }

        //Enable the insurer fields in order to be edited
        parentForm.controls.policyholderData.controls.lastName.enable();
        parentForm.controls.policyholderData.controls.middleName.enable();
        parentForm.controls.policyholderData.controls.firstName.enable();
        parentForm.controls.policyholderData.controls.egn.enable();

    }


    loadDataInsurerFromCP(){
        let parentForm = this.formService.currentForm;
        parentForm.controls.policyholderData.controls.middleName.setValue(this.userInfo.middleName);
        parentForm.controls.policyholderData.controls.lastName.setValue(this.userInfo.lastName);
        parentForm.controls.policyholderData.controls.egn.setValue(this.userInfo.egn);

        parentForm.controls.policyholderData.controls.middleName.disable()
        parentForm.controls.policyholderData.controls.lastName.disable()
        parentForm.controls.policyholderData.controls.egn.disable();
        parentForm.controls.policyholderData.controls.firstName.disable();

        //Enable the owner fields in order to be edited
        parentForm.controls.ownerData.controls.lastName.enable();
        parentForm.controls.ownerData.controls.middleName.enable();
        parentForm.controls.ownerData.controls.firstName.enable();
        parentForm.controls.ownerData.controls.egn.enable();


        if(!parentForm.controls.policyholderData.controls.email.value){
        parentForm.controls.policyholderData.controls.email.setValue(this.userInfo.email);
        }

        if(!parentForm.controls.policyholderData.controls.address.value){
        parentForm.controls.policyholderData.controls.address.setValue(this.userInfo.address);
        }
    }


    isUserRegistered(egn) {
      this.sharedService.loadingSpinner = true;
      let transformedEgn = btoa(egn);
      return this.http.post('/api/v1/validate/customer' + '?nationalId=' + transformedEgn + '&fromCp=' + this._isCustomerPortal, '')
      .pipe(
        catchError(err => {
          this.sharedService.loadingSpinner = false;
          return of(err);
        }),
        first(),
      )
      .pipe(map(result => {
        this.sharedService.loadingSpinner = false;
        return result['registered'];
      }));
    }
    
}